'use client'

import React from 'react'

import type { GridCellBlock as BlockProps } from '@/payload-types'
import { RenderBlocks } from '@/blocks/RenderBlocks'
import { cn } from '@/utilities/cn'

export const GridCellBlock: React.FC<BlockProps> = ({ layout, span, className }) => {
  return (
    <div className={cn('col-span-1', span && `lg:col-span-${span}`, className)}>
      <RenderBlocks blocks={layout ?? []} />
    </div>
  )
}
